import { ObjectTypeId } from '@isyc-react/types';
export let PermissionStatus = /*#__PURE__*/function (PermissionStatus) {
  PermissionStatus["LOADING"] = "LOADING";
  PermissionStatus["READY"] = "READY";
  PermissionStatus["ERROR"] = "ERROR";
  return PermissionStatus;
}({});
export const createEmptyUserPermissions = status => ({
  permission: {},
  status: status !== null && status !== void 0 ? status : PermissionStatus.LOADING
});
export const defaultUserPermissionObjectTypeIds = [ObjectTypeId.DOSSIER, ObjectTypeId.PARTICIPANT, ObjectTypeId.DOSSIER_TEMPLATE, ObjectTypeId.PARTICIPANT_TEMPLATE, ObjectTypeId.ARCHIVE, ObjectTypeId.USER, ObjectTypeId.PERSON, ObjectTypeId.PARAMETER, ObjectTypeId.SIGNATURE, ObjectTypeId.SIGNATUREPROCESS, ObjectTypeId.INTERACTION, ObjectTypeId.TREE, ObjectTypeId.TYPOLOGY, ObjectTypeId.DOCUMENTEDM, ObjectTypeId.DOCUMENTALGROUP, ObjectTypeId.DOCUMENTALVALIDATION, ObjectTypeId.DOCUMENTALVALIDATIONLINE];